import Pill from '@/features/ui/components/Pill'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface VariantQuantityProps {
    quantity: number
}

const VariantQuantity: FC<VariantQuantityProps> = ({ quantity }) => {
    const { t } = useTranslation()

    if (quantity <= 1) return

    return <Pill>{`${quantity} ${t('pos.productCatalog.variant', { count: quantity })}`}</Pill>
}

export default VariantQuantity
